const replaceZero = (val) => {
  return val.toString().substring(0, 1) === "0" ? val.toString().replace(/^0/, "") : val
}

const removeSpaces = (str) => {
  return str?.trim();
}

export { replaceZero, removeSpaces };